import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/** Histórico completo vive na home; esta rota só redireciona. */
export const AllApiCallsPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/", { replace: true });
    // Scroll após a home montar
    const t = window.setTimeout(() => {
      document
        .getElementById("historico-chamadas")
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 400);
    return () => window.clearTimeout(t);
  }, [navigate]);

  return null;
};

export default AllApiCallsPage;
